// extracted by mini-css-extract-plugin
export default {"top":"PageAlbum_top__WYabp","body":"PageAlbum_body__6mtcw"};